import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/site';

export default function SiteFooter() {
  return (
    <footer className="mt-auto w-full bg-primary-950 text-primary-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-accent-500 text-background-50">
                <i className="ri-movie-2-line text-xl"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                疯狂试爱<span className="text-accent-400">2</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-primary-200">{siteInfo.slogan}</p>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold tracking-wide text-background-50">内容导航</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to="/" className="text-primary-200 transition-colors hover:text-accent-400">首页</Link></li>
              <li><Link to="/news" className="text-primary-200 transition-colors hover:text-accent-400">影视资讯</Link></li>
              <li><Link to="/category/plot" className="text-primary-200 transition-colors hover:text-accent-400">剧情介绍</Link></li>
              <li><Link to="/category/feature" className="text-primary-200 transition-colors hover:text-accent-400">花絮专题</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold tracking-wide text-background-50">友情链接</h4>
            <ul className="space-y-3 text-sm">
              {siteInfo.friends.map((item) => (
                <li key={item.name}>
                  <Link to={item.url} className="text-primary-200 transition-colors hover:text-accent-400">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="mb-4 text-sm font-semibold tracking-wide text-background-50">联系我们</h4>
            <ul className="space-y-3 text-sm text-primary-200">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line mt-0.5 text-base text-accent-400"></i>
                <span className="break-all">{siteInfo.contact.email}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-phone-line mt-0.5 text-base text-accent-400"></i>
                <span>{siteInfo.contact.phone}</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-base text-accent-400"></i>
                <span>{siteInfo.contact.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-4 border-t border-primary-800 pt-6 text-sm text-primary-300 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} 疯狂试爱2 影视内容站 · 本站内容均为演示用途</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/about" className="transition-colors hover:text-accent-400">关于我们</Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">隐私政策</Link>
            <Link to="/about" className="transition-colors hover:text-accent-400">法律声明</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}